export default __webpack_public_path__ + "static/994-303783bc8db112b5256e7c60154e678e.gif";